export default "__VITE_ASSET__D3og5Bmn__"